import { Css } from "@homebound/beam";
import { BidContractHeader } from "src/components/bid-contracts/BidContractHeader";
import { useRouteParams } from "src/hooks/useRouteParams";
import {
  BidContractRevisionFragment,
  useBidContractRevisionQuery,
} from "src/routes/developments/procurement/DevelopmentContractPage.generated";
import { queryResult } from "src/utils";
import { ProjectBidContractTabs } from "./ProjectBidContractTabs";

export function ProjectBidContractPage() {
  const { bidContractRevisionId } = useRouteParams<{ bidContractRevisionId: string }>();
  const query = useBidContractRevisionQuery({ variables: { bidContractRevisionId } });
  return queryResult(query, {
    data: ({ bidContractRevision }) => {
      return <ProjectContractView bidContractRevision={bidContractRevision} />;
    },
  });
}

type ContractProp = { bidContractRevision: BidContractRevisionFragment };

function ProjectContractView({ bidContractRevision }: ContractProp) {
  return (
    <>
      <BidContractHeader selectedRevision={bidContractRevision} />
      <div css={Css.mt3.$}>
        <ProjectBidContractTabs selectedRevision={bidContractRevision} />
      </div>
    </>
  );
}
